import { render } from "./QuestionarioSaude.vue?vue&type=template&id=8df2b784&scoped=true"
import script from "./QuestionarioSaude.vue?vue&type=script&lang=js"
export * from "./QuestionarioSaude.vue?vue&type=script&lang=js"

import "./QuestionarioSaude.vue?vue&type=style&index=0&id=8df2b784&lang=scss&scoped=true"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8df2b784"]])

export default __exports__